module.exports = "<% breadcrumbs.forEach(function(breadcrumb) { %>\n<li class=\"breadcrumb-item<% if (!breadcrumb.url) { %> active <% } %>\">\n  <% if (breadcrumb.url) { %>\n    <a href=\"<%= breadcrumb.url %>\"><%= breadcrumb.label %></a>\n  <% } else { %>\n    <%= breadcrumb.label %>\n  <% } %>\n</li>\n<% }); %>\n"


//////////////////
// WEBPACK FOOTER
// ./src/static/js/views/breadcrumbs.tpl.html
// module id = eVjM
// module chunks = 5